import Icons from './icons';
import Nav from './components/Nav';
import CompanyList from './components/CompanyList';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';


function App() {
  return (
    <div>
      <Router>
        <div className="App">
          <Nav />
          <Routes>
            <Route path="/" element={""} />
            <Route path="/" element={"adfas"} />
          </Routes>
        </div>
      </Router>

      <header className="App-header">
       
        
        <p>
          State Of Nature Studios
        </p>
        <CompanyList />
        <div>

        </div>
      </header>

    </div>
  );
}

export default App;
